require('../../modules/es6.number.is-finite');
module.exports = require('../../modules/_core').Number.isFinite;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/number/is-finite.js
// module id = 278
// module chunks = 0